import React from 'react';

function PageHeader({ eyebrow, title, lead }) {
  return (
    <section className="page-header">
      <div className="container">
        {eyebrow && <div className="page-header__eyebrow">{eyebrow}</div>}
        <h1 className="page-header__title">{title}</h1>
        {lead && <p className="page-header__lead">{lead}</p>}
      </div>
    </section>
  );
}

export default PageHeader;
